
jQuery(($) => {
    $('.a-select').on('change', function (){
        if ($(this).val()){
            if (!$(this).parent().hasClass('m-field--active')){
                $(this).parent().addClass('m-field--active');
            }
        }
    });

    if($('.hero-desktop-heading-image')[0]){
        $(window).on('load', function(){
            $('.hero-desktop-heading-image').each(function(){
                let $images = $(this).find('.photos__figure');

                if(!$images) return;

                let $index = Math.floor(Math.random() * $images.length);

                $images.eq($index).fadeIn(1000);
                $images.not($images.eq($index)).css('display', 'none');
            });
        });
    }
});